'use strict';

export { isDevelopment } from './environment.service';
export { isProduction } from './environment.service';
